import { setLanguage, useLanguage, useT } from "../i18n";

/**
 * English or Arabic. Each option is written in its OWN language — "العربية" rather
 * than "Arabic" — because the person who needs it is the person who cannot read the
 * other label.
 */
export default function LanguageToggle() {
  const language = useLanguage();
  const t = useT();

  return (
    <div className="language-toggle" role="group" aria-label={t("shell.language")}>
      <button
        type="button"
        className={language === "en" ? "active" : ""}
        onClick={() => setLanguage("en")}
        aria-pressed={language === "en"}
        lang="en"
      >
        English
      </button>
      <button
        type="button"
        className={language === "ar" ? "active" : ""}
        onClick={() => setLanguage("ar")}
        aria-pressed={language === "ar"}
        lang="ar"
      >
        العربية
      </button>
    </div>
  );
}
